export const TALK_TO_OUR_EXPERTS = 'Talk to our experts'
export const LOOKING_FOR_NEW_CAR = 'Looking for a new car?'
export const CALLBACK_WIDGET_IMAGE_SRC = 'https://acko-cms.ackoassets.com/Acko_Drive_Widget_Cars_Banner_d022846f13.webp'
export const FORM_DESCRIPTION = `Talk to our advisors and get maximum discount on your new car. Leave
your contact details, we will assist you soon.`
export const DESKTOP_WIDGET_TEXT = 'Get the lowest price for your new car and an extra discount of ₹ 10,000!'
export const CONTACT_NUMBER = '18002662250'
export const CALL_US_TEXT = `Call us - ${CONTACT_NUMBER.substring(
  0,
  4,
)} ${CONTACT_NUMBER.substring(4, 4 + 3)} ${CONTACT_NUMBER.substring(4 + 3)}`
export const SERVICE_UNAVAILABLE = 'This service is unavailable at the moment.'
export const SERVICE_UNAVAILABLE_DESCRIPTION =
  'We’re working on it. Please try after some time.'
export const EXPLORE_NEW_CARS = 'Explore new cars'
export const BEST_CAR_DEALS_PROMISE =
  'We promise the best car deals and earliest delivery!'
